"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Button from 'src/components/button/Button';
import withWatchlist from 'src/components/filmwebid/withWatchlist';
import StreamingTitleWithProviders from 'src/components/streaming/streamingtitlewithproviders/StreamingTitleWithProviders';
import FilterButton from 'src/components/streaming/weeklystreamingreleases/FilterButton';
import type IWeeklyReleases from 'src/components/streaming/weeklystreamingreleases/IWeeklyReleases';
import classNames from 'classnames';
import styles from './StreamingReleasesForWeek.module.css';

//#region [Props]
type StreamingReleasesForWeekProps = {
  releases: IWeeklyReleases;
  minPopularity?: number;
  showFilteringOptions: () => void;
  filterButtonText?: string;
};
//#endregion

//#region [Component]
export default function StreamingReleasesForWeek(t0) {
  const $ = _c(30);
  const {
    releases,
    minPopularity: t1,
    showFilteringOptions,
    filterButtonText
  } = t0;
  const minPopularity = t1 === undefined ? 20 : t1;
  const [showAll, setShowAll] = useState(false);
  let t2;
  if ($[0] !== filterButtonText || $[1] !== minPopularity || $[2] !== releases.releases || $[3] !== showAll) {
    let _include = false;
    t2 = showAll || filterButtonText ? releases.releases : releases.releases.filter((release, index) => {
      if (index < 4) {
        return true;
      }
      if (release.popularity < minPopularity && index % 4 === 0) {
        _include = false;
      }
      if (release.popularity >= minPopularity || _include) {
        if (index % 4 === 0) {
          _include = true;
        }
        return true;
      }
      return false;
    });
    $[0] = filterButtonText;
    $[1] = minPopularity;
    $[2] = releases.releases;
    $[3] = showAll;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const _releases = t2;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(styles.SStreamingReleasesForWeek);
    t4 = classNames(styles.SHeader);
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames(styles.SFilterButton);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== filterButtonText || $[9] !== showFilteringOptions) {
    t6 = <FilterButton className={t5} showFilterDialog={showFilteringOptions} text={filterButtonText} />;
    $[8] = filterButtonText;
    $[9] = showFilteringOptions;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classNames(styles.SH2);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== releases.weekLabel) {
    t8 = <h2 className={t7}>{releases.weekLabel}</h2>;
    $[12] = releases.weekLabel;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <header className={t4}>{t6}{t8}</header>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== _releases.length) {
    t10 = _releases.length === 0 && <p>Ingen titler denne uken som matcher ditt filter</p>;
    $[17] = _releases.length;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== _releases || $[20] !== releases.weekLabel) {
    t11 = _releases.length > 0 && <div className={classNames(styles.SLayout)}>{_releases.map(release_0 => <WLStreamingTitleWithProviders key={`${releases.weekLabel}${release_0.id}`} data={release_0} />)}</div>;
    $[19] = _releases;
    $[20] = releases.weekLabel;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== filterButtonText || $[23] !== showAll) {
    t12 = !showAll && !filterButtonText && <Button className={classNames(styles.SShowAllButton)} text="Se alle" onClick={() => setShowAll(true)} />;
    $[22] = filterButtonText;
    $[23] = showAll;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t9) {
    t13 = <section className={t3}>{t9}{t10}{t11}{t12}</section>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
//#endregion

const WLStreamingTitleWithProviders = withWatchlist(StreamingTitleWithProviders, "data");

//#region [Styles]
//#endregion